<script setup lang="ts">
import { useI18n } from '@papershift/locale/src/i18n'
import FeatureBox from '../../components/FeatureBox.vue'
import {
  UsersIcon,
  RocketLaunchIcon,
  DoorOpenIcon,
} from '@papershift/ui/src/icons'

const { t } = useI18n()
</script>

<template>
  <div class="relative hidden w-0 flex-1 lg:block bg-slate-700">
    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <div class="text-3xl text-white font-medium my-2">
        {{ t('title') }}
      </div>

      <div class="text-xl text-white my-4">
        {{ t('subtitle') }}
      </div>

      <FeatureBox
        :title="t('personnel_file.title')"
        :subtitle="t('personnel_file.subtitle')"
        :icon="UsersIcon"
      />

      <FeatureBox
        :title="t('onboarding.title')"
        :subtitle="t('onboarding.subtitle')"
        :icon="RocketLaunchIcon"
      />

      <FeatureBox
        :title="t('offboarding.title')"
        :subtitle="t('offboarding.subtitle')"
        :icon="DoorOpenIcon"
      />
    </div>
  </div>
</template>

/* v8 ignore start */
<i18n locale="en">
title: We love productive teams
subtitle: Simple HR processes, accessible to everyone.
personnel_file:
  title: Digital Personnel File
  subtitle: Manage all important data & documents digitally and always at hand.
onboarding:
  title: Onboarding
  subtitle: Make the first day of your employees a success.
offboarding:
  title: Offboarding
  subtitle: "You always meet twice: make sure that your company is remembered positively."
</i18n>

<i18n locale="de">
title: Wir lieben produktive Teams
subtitle: Einfache HR-Prozesse, für jeden zugänglich.
personnel_file:
  title: Digitale Personalakte
  subtitle: Verwalte alle wichtigen Daten & Dokumente digital und jederzeit griffbereit.
onboarding:
  title: Onboarding
  subtitle: Mache den ersten Tag Deiner Mitarbeiter zum Erfolg.
offboarding:
  title: Offboarding
  subtitle: "Man sieht sich immer zweimal im Leben: Sorge dafür, dass Deine Firma positiv in Erinnerung bleibt."
</i18n>
/* v8 ignore stop */
